import { ACTION_FORMATS } from 'core-components/library/richTextEditor'

export const prepareSectionElements = (htmlValue: Document) => {
  const sectionElements = htmlValue.querySelectorAll('section')

  sectionElements.forEach((sectionElement) => {
    // Convert expandBlock from the old editor to the new
    if (sectionElement && sectionElement.getAttribute('class') === 'short-block') {
      const fragment = document.createDocumentFragment()
      const shortBlockTitleElement = sectionElement.querySelector('.short-block-title')
      if (shortBlockTitleElement) {
        const summaryElement = document.createElement('summary')
        summaryElement.textContent = shortBlockTitleElement.textContent
        fragment.appendChild(summaryElement)
      }

      const shortBlockDescriptionElement = sectionElement.querySelector('.short-block-description')

      if (shortBlockDescriptionElement) {
        while (shortBlockDescriptionElement.firstChild) {
          fragment.appendChild(shortBlockDescriptionElement.firstChild)
        }
      }
      const detailsElement = document.createElement('details')

      detailsElement.appendChild(fragment)

      sectionElement.replaceWith(detailsElement)
    } else if (
      sectionElement &&
      !(sectionElement.getAttribute('class') === 'action-box') &&
      !(sectionElement.getAttribute('type') as ACTION_FORMATS)
    ) {
      // Remove unnecessary sections from the old editor
      const editorBlockContent = sectionElement.querySelector('.editor-block-content')
      if (editorBlockContent) {
        const fragment = document.createDocumentFragment()
        fragment.appendChild(editorBlockContent.cloneNode(true))

        sectionElement.replaceWith(fragment)
      }
    }
  })
}
